import React, { useState, useCallback } from 'react'
import { Button, AutoRenewIcon, Skeleton } from '@pixel-nft/uikit'
import { useLendingPoolApproval, useSousApprove } from 'hooks/useApprove'
import { useTranslation } from 'contexts/Localization'
import { useERC20 } from 'hooks/useContract'
import useToast from 'hooks/useToast'
import { getAddress, getPixelAddress, getUSDTAddress } from 'utils/addressHelpers'
import { Pool } from 'state/types'

const ApprovalAction: React.FC<{ tokenAddress: string; isLoading?: boolean }> = ({
  tokenAddress,
  isLoading = false,
}) => {
  const { t } = useTranslation()
  const [requestedApproval, setRequestedApproval] = useState(false)
  const { onApprove } = useLendingPoolApproval(tokenAddress)
  const { toastSuccess, toastError } = useToast()

  const handleApprove = useCallback(async () => {
    try {
      setRequestedApproval(true)
      const txHash = await onApprove()
      if (txHash) {
        toastSuccess(t('Contract Enabled'), t('Your approval is succeed!'))
        setRequestedApproval(false)
      } else {
        // user rejected tx or didn't go thru
        toastError(t('Wallet Sign Transaction Error'), t('User rejected the request.'))
        setRequestedApproval(false)
      }
    } catch (e) {
      console.error(e)
      // toastError(t('Error'), e?.message)
    }
  }, [onApprove, setRequestedApproval, toastSuccess, toastError, t])

  return (
    <>
      {isLoading ? (
        <Skeleton width="100%" height="52px" />
      ) : (
        <Button
          isLoading={requestedApproval}
          endIcon={requestedApproval ? <AutoRenewIcon spin color="currentColor" /> : null}
          disabled={requestedApproval}
          onClick={handleApprove}
          width="100%"
        >
          {t('Approve Contract')}
        </Button>
      )}
    </>
  )
}

export default ApprovalAction
